var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { getFieldInfo, getFieldTitle } from "../../../../redux/form/form.utils";
import FormIbanSelectInline from "../FormIbanSelectInline.container";
var FormContactSelectInlineJsonFormSchema = /** @class */ (function (_super) {
    __extends(FormContactSelectInlineJsonFormSchema, _super);
    function FormContactSelectInlineJsonFormSchema() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Event handlers
        _this.handlePressExtraInfo = function () {
            var _a = _this.props, _b = _a.formContext, formContext = _b === void 0 ? {} : _b, uiSchema = _a.uiSchema;
            if (formContext.onPressExtraInfo) {
                formContext.onPressExtraInfo(uiSchema.extraInfoUrl);
            }
        };
        _this.handlePressAddIban = function () {
            var _a = _this.props, _b = _a.formContext, formContext = _b === void 0 ? {} : _b, name = _a.name, formData = _a.formData;
            if (formContext.onSelectMore) {
                formContext.onSelectMore(name, formData);
            }
        };
        return _this;
    }
    FormContactSelectInlineJsonFormSchema.prototype.render = function () {
        var _a = this.props, name = _a.name, uiSchema = _a.uiSchema, _b = _a.rawErrors, rawErrors = _b === void 0 ? [] : _b, onChange = _a.onChange, formData = _a.formData, _c = _a.formContext, formContext = _c === void 0 ? {} : _c;
        var customUiSchema = uiSchema;
        var customIsFetchingSelector = customUiSchema.customIsFetchingSelector, customIbansSelector = customUiSchema.customIbansSelector, customGetIbansActions = customUiSchema.customGetIbansActions, isDisabled = customUiSchema.isDisabled;
        var disabled = isDisabled
            ? isDisabled(formContext.getAllFormData())
            : undefined;
        var handleSelectIban = function (contactId) {
            onChange(contactId);
            // TODO: Timeout?
            setTimeout(function () {
                if (formContext.onFieldChange) {
                    formContext.onFieldChange(name, contactId);
                }
            }, 0);
        };
        var customIsFetchingSelectorEnhanced = function (state) {
            return customIsFetchingSelector(state, 
            // @ts-ignore
            formContext.getFormData());
        };
        var customIbansSelectorEnhanced = function (state) {
            return customIbansSelector(state, 
            // @ts-ignore
            formContext.getFormData());
        };
        var customGetIbansActionsEnhanced = 
        // @ts-ignore
        customGetIbansActions(formContext.getFormData());
        return (_jsx(FormIbanSelectInline, __assign({}, customUiSchema, { onPressExtraInfo: this.handlePressExtraInfo, customIsFetchingSelector: customIsFetchingSelectorEnhanced, customIbansSelector: customIbansSelectorEnhanced, customGetIbansActions: customGetIbansActionsEnhanced, title: getFieldTitle(customUiSchema, formContext), info: getFieldInfo(customUiSchema, formContext), onSelectIban: handleSelectIban, onPressAddIban: this.handlePressAddIban, selectedIbanId: formData, error: rawErrors[0], disabled: disabled })));
    };
    return FormContactSelectInlineJsonFormSchema;
}(React.PureComponent));
// eslint-disable-next-line import/no-default-export
export default FormContactSelectInlineJsonFormSchema;
